import React from "react";
import Root from "./root";

export const wrapRootElement = ({ element }) => <Root>{element}</Root>;
